import AreaChartWithAxis from "./AreaChartWithAxis.jsx";

export default AreaChartWithAxis;



// WEBPACK FOOTER //
// ./src/components/d3Components/multiAreaChart/AreaChartWithAxis/index.js